import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { RequestPhaseInput } from '../../../../Request'
import { TASK_FORM_PHASE_FIELD_NAME } from '../../TaskForm.constants'

function PhaseField({ isEmptyServiceRequest, isLoading, items }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      Component={RequestPhaseInput}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Task.FormPhaseFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      isLoading={isLoading}
      items={items}
      name={TASK_FORM_PHASE_FIELD_NAME}
      placeholder={t('Task.FormPhaseFieldPlaceholderKey')}
      tooltip={
        isEmptyServiceRequest
          ? t('Task.FormPhaseFieldRequestNotSelectedTooltipKey')
          : null
      }
    />
  )
}

export default PhaseField
